// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2peJ-","header":"PatientQuestionnaire_header__2IdJ6","info":"PatientQuestionnaire_info__1eUzi"};